export default __webpack_public_path__ + "static/media/floor.b2f6aa73.png";